module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-1@2x_af1a0b62b5357bcd45a7029dba74941a.png";